// extracted by mini-css-extract-plugin
module.exports = {"right":"styles_right__3hzoE"};